import { CURRENCIES } from "../../utils/constants/currencies";

export const CHANGE_CURRENCY = "CHANGE_CURRENCY";

export const changeCurrency = (currencyName) => {
    return (dispatch) => {
        dispatch({
            type: CHANGE_CURRENCY,
            payload: { currencyName, currencyRate: CURRENCIES[currencyName] },
        });
    };
};
